export default function(gantt) {

	gantt.getTaskType = function (type) {
		return "task";
	};
};